import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBlogsAsync } from "./BlogsAPI";

const sliceName = "blogs";
const initialState = {
    blogs: [],
    isLoading: false,
    isError: false,
    errorMessage: ''
};

export const fetchBlogs = createAsyncThunk(`${sliceName}/fetchBlogs`, getBlogsAsync);

const blogsSlice = createSlice({
    name: sliceName,
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlogs.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(fetchBlogs.fulfilled, (state, action) => {
                state.isLoading = false;
                state.blogs = action.payload;
            })
            .addCase(fetchBlogs.rejected, (state, action) => {
                state.isError = true;
                state.isLoading = false;
                state.errorMessage = action.error?.message;
                state.blogs = [];
            });
    }
});

export default blogsSlice.reducer;
